"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiMenuItemThemeOptions = void 0;
const material_1 = require("@mui/material");
exports.MuiMenuItemThemeOptions = {
    defaultProps: {
        disableRipple: true,
        disableTouchRipple: true,
    },
    styleOverrides: {
        root: ({ theme }) => ({
            borderRadius: "4px",
            padding: theme.spacing(1, 1.5),
            ...theme.typography.smallTextLabels,
            [`& .${material_1.listItemIconClasses.root}`]: {
                color: theme.palette.gray[50],
                minWidth: "unset",
                marginRight: 12,
                alignItems: "flex-start",
            },
            [`& .${material_1.listItemAvatarClasses.root}`]: {
                border: "2px solid transparent",
                marginRight: "12px",
                borderRadius: "50%",
                minWidth: "unset",
            },
            [`& .${material_1.listItemTextClasses.primary}`]: {
                ...theme.typography.smallTextLabels,
                fontWeight: 500,
                color: theme.palette.gray[80],
            },
            [`& .${material_1.listItemTextClasses.secondary}`]: {
                ...theme.typography.microText,
                marginTop: "2px",
                fontWeight: 500,
                color: theme.palette.gray[50],
            },
            [`& .${material_1.listItemSecondaryActionClasses.root}`]: {
                ...theme.typography.smallTextLabels,
                fontWeight: 500,
                color: theme.palette.gray[50],
                "& svg": {
                    fontSize: 12,
                    color: "currentColor",
                },
            },
            // HOVER STYLES
            "&:hover": {
                backgroundColor: theme.palette.gray[20],
                color: theme.palette.gray[80],
                [`& .${material_1.listItemIconClasses.root}`]: {
                    color: theme.palette.gray[60],
                },
                [`& .${material_1.listItemTextClasses.primary}`]: {
                    color: theme.palette.gray[90],
                },
                [`& .${material_1.listItemTextClasses.secondary}`]: {
                    color: theme.palette.gray[70],
                },
                [`& .${material_1.listItemAvatarClasses.root}`]: {
                    borderColor: theme.palette.white,
                },
                [`& .${material_1.listItemSecondaryActionClasses.root}`]: {
                    color: theme.palette.gray[70],
                },
            },
            // FOCUS STYLES
            "&:focus": {
                outline: "none",
            },
            [`&.${material_1.menuItemClasses.focusVisible}, &:focus`]: {
                boxShadow: `0px 0px 0px 2px ${theme.palette.white}, 0px 0px 0px 4px ${theme.palette.blue[70]}`,
                backgroundColor: "transparent",
            },
            [`&.${material_1.menuItemClasses.selected}, &.${material_1.menuItemClasses.selected}:hover, &:active`]: {
                backgroundColor: theme.palette.blue[70],
                color: theme.palette.common.white,
                boxShadow: "unset",
                [`& .${material_1.listItemIconClasses.root}`]: {
                    color: theme.palette.blue[30],
                },
                [`& .${material_1.listItemTextClasses.primary}`]: {
                    color: theme.palette.white,
                },
                [`& .${material_1.listItemTextClasses.secondary}`]: {
                    color: theme.palette.blue[30],
                },
                [`& .${material_1.listItemAvatarClasses.root}`]: {
                    borderColor: theme.palette.white,
                },
                [`& .${material_1.listItemSecondaryActionClasses.root}`]: {
                    color: theme.palette.blue[30],
                },
                /**
                 * @todo add styles for when ownerState.dense = true
                 * This will handle scenarios where the menu item is smaller
                 */
            },
        }),
    },
};
